import { h } from 'preact';
import {ProductCard} from "../index";
import s from "./mostSearched.module.css";
import { useAppContext } from '../../contexts';
import { useEffect } from 'preact/hooks';
import useGtmContext from '../../contexts/GTMContext/gtmContext';

const MostSearched = props => {
    // Destructured props
    const {
        data,
        gridSize = 4,
        isContainer = true
    } = props;

    const GRID_SIZE = {
        2: "md:grid-cols-2",
        3: "md:grid-cols-3",
        4: "md:grid-cols-4",
    }

    const {highContrast} = useAppContext();

    const {handleImpressionViewEvent} = useGtmContext();

    useEffect(() => {
        if (!data || !data.length) {
            return;
        }
        
        handleImpressionViewEvent(data, 'Produtos Mais Buscados', 'mostSearch');
    }, [data]);

    return !!data && data.length > 0 ? (
        <div className={`mb-20 md:mb-32 ${(isContainer ? "container-fluid" : "")}`}>
            <div className={`${(isContainer ? "sabin-container" : "")}`}>
                <h2 className={`${s.mostSearchedTitle} ${highContrast ? "highTitleFirst" : ""}`} data-testid="most-searched-title">
                    Serviços mais buscados:
                </h2>
                <div className={`grid grid-cols-2 ${GRID_SIZE[gridSize]} gap-x-[15px] md:gap-x-bs-gutter gap-y-6`}>
                    {data.map(item => {
                        return (
                            <ProductCard
                                key={item.id}
                                product={item}
                                handleClick={() => {}}
                            />
                        )
                    })}
                </div>
            </div>
        </div>
    ) : null;
}

export default MostSearched;
